import { atom } from 'recoil';
import type { TimeLimitedDiscountDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/common';
import { timeLimitedDiscountsSelector } from '../selectors/timeLimitedDiscountsSelector';

export const timeLimitedDiscountsAtom = atom<TimeLimitedDiscountDTO[]>({
    key: 'timeLimitedDiscountsAtom',
    default: timeLimitedDiscountsSelector
});
